import React, { memo } from 'react';
import isEqual from 'react-fast-compare';
import { Menu as SUIMenu, MenuProps as SUIMenuProps } from 'semantic-ui-react';

export type MenuProps = SUIMenuProps & {};

const Menu: React.FC<MenuProps> = ({ ...rest }) => <SUIMenu {...rest} />;

export default memo(Menu, isEqual);
